export default __webpack_public_path__ + "static/media/decoration.bdfca999.webp";